/* eslint-disable angular/controller-name */

angular.
module("dx.webapp.printing").
controller("dxPrintFinalGradesController", function PrintFinalGradesController(
	DX_EXAM_PARTS,
	dxBitFlagsHelper
) {
	"use strict";

	this.DX_EXAM_PARTS = DX_EXAM_PARTS;
	this.dxBitFlagsHelper = dxBitFlagsHelper;

	var self = this;

	self.displayName = getDisplayName();


	function getDisplayName() {
		var displayName = "";

		if (self.showStudentNames) {
			displayName = self.student.getName(false, false);
		} else if (self.showStudentCodes) {
			displayName = "(" + self.student.code + ")";
		} else if (self.showEmail) {
			displayName = self.student.email;
		} else {
			//Default option for anonymous exams
			displayName = self.student.getName(false, false);
		}
		return displayName;
	}
});
